import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
import { Leaf, Lock, Home } from 'lucide-react';
import { StepIndicator } from './StepIndicator';

export function TeamBLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col">
      <header className="sticky top-0 z-10 border-b border-slate-200 bg-white/90 backdrop-blur">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-3">
          <Link to="/" className="flex items-center gap-2 text-base font-semibold text-teamB-primary">
            <Leaf className="h-5 w-5" />
            <span>叶子在说话</span>
          </Link>
          <div className="flex items-center gap-2">
            <span className="hidden text-xs text-teamB-primary sm:inline badge bg-teamB-primary/10">
              B 队 · 王晟骅 · 易陈 · 华睿
            </span>
            <Link
              to="/"
              aria-label="返回主页"
              title="返回主页"
              className="flex h-9 w-9 items-center justify-center rounded-md text-teamB-primary transition hover:bg-teamB-primary/10"
            >
              <Home className="h-5 w-5" />
            </Link>
          </div>
        </div>
      </header>
      <main className="mx-auto w-full max-w-3xl flex-1 px-4 py-4">
        <StepIndicator />
        {children}
      </main>
      <footer className="border-t border-slate-200 bg-white py-3 text-center text-xs text-slate-400">
        <div className="flex items-center justify-center gap-1">
          <Lock className="h-3 w-3" />
          <span>首版固定支持 1 种植物(绿萝) · 不使用药剂/施肥</span>
        </div>
        <div className="mt-1">2026 · AI 智能体开发专项赛 · 叶子在说话</div>
      </footer>
    </div>
  );
}
